import React from "react";
import cs from "@/utils/classNames";
import { IconProps } from "../interface";

const IconFire = React.forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <svg
    width="17"
    height="20"
    viewBox="0 0 17 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    className={cs(props?.className, "yfm-icon-fire")}
  >
    <path
      d="M13.082 6.5L11.582 8C11.582 8 11.582 2 6.582 0C6.582 0 6.082 5.5 3.582 7.5C1.082 9.5 -3.918 15.5 6.082 20C6.082 20 1.082 14.5 7.582 10.5C7.582 10.5 7.082 12.5 9.582 14.5C12.082 16.5 9.582 20 9.582 20C9.582 20 21.582 17 13.082 6.5Z"
      fill="url(#paint0_linear_1406_154)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1406_154"
        x1="8.11276"
        y1="-1.88335e-07"
        x2="15.9991"
        y2="18"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF7070" />
        <stop offset="1" stopColor="#FF0000" />
      </linearGradient>
    </defs>
  </svg>
));

IconFire.displayName = "IconFire";

export default IconFire;
